import request from "@/utils/request"
//获取用户资产数据
export function getUserAsset(params) {
    return request({
        method: 'get',
        url: 'actual/personal/asset/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }

    })

}

//获取用户收益
export function getPersonalEarning(params) {
    return request({
        method: 'get',
        url: 'actual/personal/earning/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })
}

//获取用户持仓
export function getPersonalPosition(params) {
    return request({
        method: 'get',
        url: 'actual/personal/position/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })
}
//获取用户挂单情
export function getPersonalOrder(params) {
    return request({
        method: 'get',
        url: 'actual/personal/order/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })
}
//获取历史记录
export function getPersonalHistory(params) {
    return request({
        method: 'get',
        url: 'actual/personal/history/',
        params: params,
        headers: {
            token: localStorage.getItem("token")
        }
    })
}




// WEBPACK FOOTER //
// ./src/api/User.js